import React from "react";
import styles from './EvaluationRequestStudentCard.module.scss';
import EvaluationStatus from "../evaluationStatus/EvaluationStatus";
import PropTypes from "prop-types";
import { getDayFromDate, getMonthYearFromDate } from "../../utils/timeUtils";

const EvaluationRequestStudentCard = ({
  date,
  data,
  status
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.date}>
          <div className={styles.day}>{getDayFromDate(date)}</div>
          <div className={styles.month}>{getMonthYearFromDate(date)}</div>
        </div>
        <table className={styles.dataTable}>
          <tbody>
            {data.map((item) => (
              <tr key={item.label}>
                <th>{item.label}</th>
                <td>{item.text}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.status}>
        {status === 'Pending' ? 
          <span className={styles.pending}>Request Sent</span> :
          <EvaluationStatus status={status} />}
      </div>
    </div>
  );
};

EvaluationRequestStudentCard.propTypes = {
  date: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      text: PropTypes.any.isRequired,
    })
  ).isRequired,
  status: PropTypes.oneOf(['Pending', 'Accepted', 'Declined']).isRequired,
}

export default EvaluationRequestStudentCard;